var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEclipseAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4376 2.71926C9.33718 1.60063 7.87584 0.982422 6.30316 0.982422C5.18738 0.982422 4.11182 1.29752 3.19648 1.89151C1.5078 2.95481 0.500244 4.78475 0.500244 6.78492C0.500244 7.3929 0.593133 7.9931 0.777134 8.56886C1.46225 10.6917 3.31892 12.2279 5.52671 12.527C6.58005 13.5983 8.04361 14.2651 9.66118 14.2651C12.8603 14.2651 15.4625 11.6621 15.4625 8.46331C15.4625 5.52829 13.2696 3.10103 10.4376 2.71926ZM1.43358 8.3582C1.27203 7.85178 1.1898 7.32157 1.1898 6.78492C1.1898 5.02319 2.07736 3.41146 3.56782 2.47193C4.37471 1.94862 5.32027 1.67173 6.30294 1.67173C7.4185 1.67173 8.46828 2.02661 9.34251 2.67726C6.29094 2.84414 3.85826 5.37185 3.85826 8.46309C3.85826 9.64839 4.21715 10.7508 4.83004 11.6708C3.24137 11.1915 1.95292 9.96771 1.43358 8.3582ZM9.66118 13.5756C6.84183 13.5756 4.54804 11.2826 4.54804 8.46331C4.54804 5.64406 6.84183 3.35102 9.66118 3.35102C12.4799 3.35102 14.773 5.64406 14.773 8.46331C14.773 11.2826 12.4796 13.5756 9.66118 13.5756Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.77681 13.8586L1.9948 15.6401C1.86013 15.7748 1.86013 15.993 1.9948 16.1277C2.06213 16.195 2.15036 16.2288 2.23858 16.2288C2.3268 16.2288 2.41502 16.195 2.48258 16.1277L4.26459 14.3462C4.39926 14.2117 4.39926 13.9933 4.26459 13.8586C4.12992 13.7242 3.9117 13.7242 3.77681 13.8586Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.66056 16.0947C9.47012 16.0947 9.31567 16.2489 9.31567 16.4396V18.9584C9.31567 19.1489 9.4699 19.3033 9.66056 19.3033C9.85123 19.3033 10.0055 19.1491 10.0055 18.9584V16.4396C10.0052 16.2489 9.85101 16.0947 9.66056 16.0947Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.5439 13.8586C15.4092 13.7242 15.191 13.7242 15.0563 13.8586C14.9217 13.9933 14.9217 14.2117 15.0563 14.3462L16.8377 16.1277C16.9052 16.195 16.9932 16.2288 17.0817 16.2288C17.1697 16.2288 17.2581 16.195 17.3254 16.1277C17.4601 15.993 17.4601 15.7748 17.3254 15.6401L15.5439 13.8586Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.1551 8.11816H17.6362C17.4457 8.11816 17.2913 8.27216 17.2913 8.46304C17.2913 8.65348 17.4455 8.80792 17.6362 8.80792H20.1551C20.3455 8.80792 20.4999 8.6537 20.4999 8.46304C20.4999 8.27238 20.3457 8.11816 20.1551 8.11816Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.3009 3.16842C15.3891 3.16842 15.4773 3.13464 15.5449 3.06731L17.3262 1.2858C17.4609 1.15114 17.4609 0.932925 17.3262 0.798263C17.1918 0.6636 16.9733 0.6636 16.8386 0.798263L15.0573 2.57954C14.9226 2.71421 14.9226 2.93242 15.0573 3.06708C15.1244 3.13464 15.2126 3.16842 15.3009 3.16842Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseAnalysis);
export default __webpack_public_path__ + "static/media/EclipseAnalysis.0694858b6c11a7fb13274b21698528e1.svg";
export { ForwardRef as ReactComponent };